import id from 'vuetify/lib/locale/id';
import ja from 'vuetify/lib/locale/ja';

import vi from './vi';

export default { ja, id, vi };
